import $ from 'jquery';
import { loadSelectTags } from '~src/sidebar/index';
import { modifyState } from '~src/state';
import { handleSidebarImages } from '~src/sidebar/index';

// Tag images
const onClickImageTag = async (event) => {
  const tagName = $(event.currentTarget).attr('data-name');
  const tagId = $(event.currentTarget).attr('data-id');
  modifyState('sidebarCurrentImagesTag', tagName.toLowerCase());
  $('#select-ricerca-immagini').val(tagId).trigger('change');
  await handleSidebarImages();
};

export const displaySidebarImagesTag = () => {
  loadSelectTags();
  const mainTags = window.editorConfig.sidebarTags.items.filter(
    (tag) => tag.isMainCategoryImg === true
  );
  const { ids, html } = mainTags.reduce(
    (acc, item) => {
      const itemId = `editor-sidebar-add-canvas-image-tag-${item.objectId}`;

      acc.html += `<div
                    id="${itemId}"
                    data-name="${item.name}"
                    data-id="${item.objectId}"  
                    class="block-with-image-tag">
                    <div class="block-image lazy overlay" data-bg="${item.img.url}">
                    </div>
                    <div class="block-name-tag text-center p-3 h5">${item.name}</div>
                  </div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onClickImageTag);
      $('body').on('click', id, onClickImageTag);
    });
  }

  $('#tab-immagini .items-container-tag-grid').html(html);

  window.lazyLoadInstance.update();
};
